import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";
import Stats from "./Stats";

const DashboardHome = () => {
  const [user, userLoading] = useAuthState(auth);
  const { data: totalData, isLoading } = useQuery("totalData", () =>
    fetch(`https://evening-peak-35730.herokuapp.com/getTotal/${user?.email}`, {
      method: "get",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => {
      return res.json();
    })
  );

  if (isLoading || userLoading) {
    return <Loading></Loading>;
  }
  // console.log(totalData);

  let today = new Date();
  let date =
    today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();
  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
      <Stats title="Total Amount" total={totalData?.totalAmount}></Stats>
      <Stats
        title="Total Orders Delivered"
        total={totalData?.totalDeliveredOrders}
      ></Stats>
      <Stats title="Total Brands" total={totalData?.totalBrands}></Stats>
      <Stats title="Total Products" total={totalData?.totalProducts}></Stats>
      <Stats
        title={`Today Total Amount (${date})`}
        total={totalData?.todayTotalAmount}
      ></Stats>
      <Stats
        title={`Today Total Orders (${date})`}
        total={totalData?.todayTotalOrders}
      ></Stats>
      <Stats
        title={`Today Total Delivered Orders (${date})`}
        total={totalData?.todayTotalDeliveredOrders}
      ></Stats>
    </div>
  );
};

export default DashboardHome;
